import { alpha } from '@mui/material/styles';
export default function Drawer(theme) {
    return {
        MuiDrawer: {
            styleOverrides: {
                modal: {
                    '&[role="presentation"]': {
                        '&.MuiDrawer-anchorLeft > .MuiDrawer-paper': {
                            boxShadow: `8px 24px 24px 12px ${alpha(theme.palette.grey[900], 0.16)}`,
                            ...theme.applyStyles('dark', {
                                boxShadow: `8px 24px 24px 12px ${alpha(theme.palette.grey[900], 0.48)}`
                            })
                        },
                        '&.MuiDrawer-anchorRight > .MuiDrawer-paper': {
                            boxShadow: `-8px 24px 24px 12px ${alpha(theme.palette.grey[900], 0.16)}`,
                            ...theme.applyStyles('dark', {
                                boxShadow: `-8px 24px 24px 12px ${alpha(theme.palette.grey[900], 0.48)}`
                            })
                        }
                    }
                }
            }
        }
    };
}
